import styled from 'styled-components';

const AttachSurveyModalWrapper = styled.div`
  width: 1098px;
  height: 680px;
  overflow-y: auto;
`;

export default AttachSurveyModalWrapper;
